import { competeScore } from "./competitiveSort";

export const NA = "Not available";
const usd = (v) => (v == null ? NA : `$${Math.round(v).toLocaleString()}`);
const pct = (v) => (v == null ? NA : `${Math.round(v)}%`);

export function trueCostTotal(r) {
  const c = r?.true_cost || {};
  if (c.tuition_usd == null || c.complete === false) return null;
  return (c.tuition_usd || 0) + (c.fees_usd || 0) + (c.accommodation_usd || 0) + (c.food_usd || 0);
}

// Each line reads only values already on the Quick Check row; missing ones say so.
export const COMPARE_LINES = [
  ["Country", (r) => [r.country, r.campus].filter(Boolean).join(" · ") || NA],
  ["Grade-match band", (r) => r.classification?.label || r.classification?.bucket || NA],
  ["Grade gap", (r) => (r.classification?.gap_score == null ? NA : Number(r.classification.gap_score).toFixed(2))],
  ["Compete score", (r) => (competeScore(r) == null ? NA : String(Math.round(competeScore(r) * 100)))],
  ["True annual cost", (r) => (trueCostTotal(r) == null ? `${NA} (tuition unknown)` : usd(trueCostTotal(r)))],
  ["· Tuition", (r) => usd(r.true_cost?.tuition_usd)],
  ["· Fees", (r) => usd(r.true_cost?.fees_usd)],
  ["· Accommodation", (r) => usd(r.true_cost?.accommodation_usd)],
  ["· Food", (r) => usd(r.true_cost?.food_usd)],
  ["1-yr graduate salary", (r) => usd(r.median_earnings_1yr_usd)],
];

